import ServicePerson from '../../src/legacy/ServicePerson';
export default ServicePerson;
